import { Voice } from "../text-to-speech.model";

export const naturalVoicesEnGb: Array<Voice> = [
    { 
        isRemote: true,
        default: false,
        lang: 'en-GB',
        localService: false,
        name: 'daphne',
        displayName: 'Natural Voice - Child - Female',
        voiceURI: 'narakeetTextToSpeech?voice=daphne'
    }, 
    { 
        isRemote: true,
        default: false,
        lang: 'en-GB',
        localService: false,
        name: 'ollie',
        displayName: 'Natural Voice - Child - Male',
        voiceURI: 'narakeetTextToSpeech?voice=ollie'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'en-GB',
        localService: false,
        name: 'beatrice',
        displayName: 'Natural Voice - Adult - Female',
        voiceURI: 'narakeetTextToSpeech?voice=beatrice'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'en-GB',
        localService: false,
        name: 'edward',
        displayName: 'Natural Voice - Adult - Male',
        voiceURI: 'narakeetTextToSpeech?voice=edward'
    },
];